import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import FeatherIcon from 'feather-icons-react';
import './BitacoraUploadZone.scss';

const BitacoraUploadZone = ({ label, value, onChange, onClear, disabled, accept = 'image/*' }) => {
  const { t } = useTranslation('finance');
  const inputRef = useRef(null);

  const handleClick = () => {
    if (disabled) return;
    if (value) return;
    inputRef.current?.click();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || !e.dataTransfer.files?.length) return;
    const file = e.dataTransfer.files[0];
    if (file.type.startsWith('image/')) onChange(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleInputChange = (e) => {
    const file = e.target.files?.[0];
    if (file) onChange(file);
    e.target.value = '';
  };

  if (value?.url) {
    return (
      <div className="bitacora-upload-zone bitacora-upload-zone--has-file">
        <img src={value.url} alt={label} className="bitacora-upload-zone-preview" />
        {!disabled && (
          <button type="button" className="bitacora-upload-zone-replace" onClick={() => inputRef.current?.click()}>
            <FeatherIcon icon="refresh-cw" size={14} />
            {t('bitacora.replace')}
          </button>
        )}
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          onChange={handleInputChange}
          className="bitacora-upload-zone-input-hidden"
        />
      </div>
    );
  }

  return (
    <div
      role="button"
      tabIndex={0}
      className="bitacora-upload-zone"
      onClick={handleClick}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleInputChange}
        disabled={disabled}
        className="bitacora-upload-zone-input-hidden"
      />
      <FeatherIcon icon="upload-cloud" size={32} className="bitacora-upload-zone-icon" />
      <p className="bitacora-upload-zone-text">{t('bitacora.uploadHint')}</p>
    </div>
  );
};

export default BitacoraUploadZone;
